import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-believinghappy-thework.jpg`;
const ALT = "A desk scene with an open laptop, handwritten workshop notes, glasses and a pen, with a copy of 'The Word You Carry' resting on top of the papers.";

export function TheWork() {
  return (
    <section
      data-testid="believing-happy-thework-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[53px] md:pt-[62px] pb-[53px] md:pb-[62px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-12 gap-y-10 items-start">

          {/* Copy — left */}
          <div className="order-2 lg:order-1 lg:col-span-5 lg:col-start-1 reveal">
            <h2
              data-testid="believing-happy-thework-headline"
              className="font-display text-[32px] sm:text-[42px] lg:text-[46px] leading-[1.16] tracking-tight text-[#1C1917]"
            >
              Mostly, it starts with paying attention.
            </h2>

            <div className="mt-6 space-y-4 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-lg">
              <p>
                A question you can&rsquo;t quite shake.
                <br />
                A word you keep returning to.
                <br />
                Something you write in the margin.
                <br />
                A conversation that makes you think differently.
                <br />
                A page in a book that feels suspiciously like it was written
                for you.
              </p>
              <p>
                You notice.
                <br />
                You get curious.
                <br />
                You write things down.
                <br />
                You tell yourself the truth.
              </p>
              <p>
                Then, instead of demanding a complete plan, you try one
                small thing and see what happens.
              </p>
              <p className="text-[#1C1917]">
                That&rsquo;s much of the work we do here.
                <br />
                Not designing a perfect life on paper.
                <br />
                Getting better at recognizing your own.
              </p>
            </div>
          </div>

          {/* Image — large, right, native ratio preserved (830:1151, zero crop) */}
          <div className="order-1 lg:order-2 lg:col-span-6 lg:col-start-7">
            <div className="relative w-full max-w-md mx-auto lg:max-w-none aspect-[830/1151] reveal">
              <FeatheredImage
                src={IMG}
                alt={ALT}
                testId="believing-happy-thework-image"
                objectPosition="center"
                featherLeft={6}
                featherRight={6}
                featherTop={6}
                featherBottom={6}
                className="absolute inset-0"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
